import type { PlaycastEnvironmentEnum } from '@playcastdotio/CoreTypes';
import cfg from './config.json';
import { generateRoutes, GlobalRoutes } from './routes';

type BaseConfig = {
  PHASE: string;
  BRANCH: string;
  VERSION: string;
  BUILD_NUMBER: string;
  ENVIRONMENT: PlaycastEnvironmentEnum;
  CLERK_PUBLIC_KEY: string;
  USE_EXPERIMENTAL: boolean;
  GA_TRACKING_ID: string;
  MACRO_EDITOR_ENABLED: boolean;
}

let CONFIG: BaseConfig & GlobalRoutes = {
  PHASE: 'beta',
  BRANCH: cfg?.BRANCH ?? 'unknown',
  VERSION: cfg?.VERSION ?? '0.0.1-local',
  BUILD_NUMBER: cfg?.BUILD_NUMBER ?? 'local',
  ENVIRONMENT: (cfg?.ENVIRONMENT as PlaycastEnvironmentEnum) ?? ('development' as PlaycastEnvironmentEnum),
  CLERK_PUBLIC_KEY: cfg?.CLERK_PUBLIC_KEY ?? '',
  USE_EXPERIMENTAL: cfg?.USE_EXPERIMENTAL ?? false,
  GA_TRACKING_ID: cfg?.GA_TRACKING_ID ?? '',
  MACRO_EDITOR_ENABLED: cfg?.MACRO_EDITOR_ENABLED ?? false,

  // INFRA
  API_BASE_URL: cfg?.API_BASE_URL ?? 'http://localhost:3030/',
  REALTIME_API_WEBSOCKET_URL: cfg?.REALTIME_API_WEBSOCKET_URL ?? 'http://localhost:3210/ws',
  REALTIME_API_BASE_URL: cfg?.REALTIME_API_BASE_URL ?? 'http://localhost:3000/',
  METRICS_API_BASE_URL: cfg?.METRICS_API_BASE_URL ?? 'http://localhost:3031/',
  ANALYTICS_API_URL: cfg?.ANALYTICS_API_URL ?? 'https://c829ww805i.execute-api.us-east-1.amazonaws.com/dev/data',
  // WEBSITES
  PRIME_PLAYER_BASE_URL: cfg?.PRIME_PLAYER_BASE_URL ?? 'http://localhost:4204/',
  PAVILION_PLAYER_BASE_URL: cfg?.PAVILION_PLAYER_BASE_URL ?? 'http://pavilion.localhost:4204/',
  MARKETING_BASE_URL: cfg?.MARKETING_BASE_URL ?? 'http://localhost:4204/',
  DEMO_BASE_URL: cfg?.DEMO_BASE_URL ?? 'http://localhost:4206/',
  BEACON_BASE_URL: cfg?.BEACON_BASE_URL ?? 'http://localhost:4206/',
  DASHBOARD_BASE_URL: cfg?.DASHBOARD_BASE_URL ?? 'http://localhost:4200/',
  ADMIN_DASHBOARD_BASE_URL: cfg?.ADMIN_DASHBOARD_BASE_URL ?? 'http://localhost:4400/',
  MACRO_EDITOR_BASE_URL: cfg?.MACRO_EDITOR_BASE_URL ?? 'http://localhost:4402/',
  // DOWNLOAD URLS
  PLAYCAST_DOWNLOAD_URL: cfg?.PLAYCAST_DOWNLOAD_URL ?? 'https://playcast-build-artifacts.s3.amazonaws.com/test/Playcast-Bootstrapper-0.0.1-unknown.exe',
  PAVILION_DOWNLOAD_URL: cfg?.PAVILION_DOWNLOAD_URL ?? 'https://playcast-build-artifacts.s3.amazonaws.com/test/Pavilion-Installer-0.0.1-unknown.exe',
};

const newRoutes = generateRoutes(CONFIG.BRANCH, CONFIG.VERSION);
CONFIG = {
  ...CONFIG,
  ...newRoutes,
};

export default CONFIG;

export const VERSION = CONFIG.VERSION;
export const BUILD_NUMBER = CONFIG.BUILD_NUMBER;
export const ENVIRONMENT = CONFIG.ENVIRONMENT;
export const BRANCH = CONFIG.BRANCH;
